import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-post-graduate',
  templateUrl: './post-graduate.component.html',
  styleUrls: ['./post-graduate.component.scss']
})
export class PostGraduateComponent implements OnInit {
    cards = [
        {
            title: '',
            subheading: 'ARNI School of Technology',
            programs: 6,
            course: 12,
            specialization: 8,
            icon: 'fa fa-laptop-code',
            iconColor: 'text-blue-600',
            url: '/schools/arni-school-of-technology'
        },
        {
            title: '',
            subheading: 'ARNI School of Allied Health Sciences',
            programs: 1,
            course: 2,
            specialization: 0,
            icon: 'fa fa-heartbeat',
            iconColor: 'text-red-500',
            url: '/schools/arni-school-of-allied-health-science'
        },
        {
            title: '',
            subheading: 'ARNI School of Business Management & Commerce',
            programs: 4,
            course: 6,
            specialization: 3,
            icon: 'fa fa-briefcase',
            iconColor: 'text-yellow-600',
            url: '/schools/arni-school-of-business-management-and-commerce'
        },
        {
            title: '',
            subheading: 'ARNI School of Pharmacy',
            programs: 3,
            course: 3,
            specialization: 5,
            icon: 'fa fa-prescription-bottle-alt',
            iconColor: 'text-green-600',
            url: '/schools/arni-school-of-pharmacy'
        },
        {
            title: '',
            subheading: 'ARNI School of Arts & Humanities',
            programs: 3,
            course: 11,
            specialization: 7,
            icon: 'fa fa-palette',
            iconColor: 'text-pink-500',
            url: '/schools/arni-school-of-art-and-humanities'
        },
        {
            title: '',
            subheading: 'ARNI School of Basic Sciences & Bio-Technology',
            programs: 6,
            course: 17,
            specialization: 20,
            icon: 'fa fa-dna',
            iconColor: 'text-purple-600',
            url: '/schools/arni-school-of-basic-science-and-biotechnology'
        },
        {
            title: '',
            subheading: 'ARNI School of Law',
            programs: 2,
            course: 4,
            specialization: 0,
            icon: 'fa fa-gavel',
            iconColor: 'text-gray-700',
            url: '/schools/arni-school-of-law'
        },
        {
            title: '',
            subheading: 'ARNI School of Hotel Management & Tourism',
            programs: 1,
            course: 1,
            specialization: 0,
            icon: 'fa fa-hotel',
            iconColor: 'text-orange-500',
            url: '/schools/arni-school-of-hotel-management-and-tourism'
        }
    ];

    constructor(private router: Router) {
    }

    ngOnInit(): void {
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

}
